import Flex from '@/components/ui/Flex';
import Page from '../../components/ui/Page';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../../components/ui/Tabs';
import AccountPage from './AccountPage';
import BillingPage from './BillingPage';

export default function SettingsPage() {
  return (
    <Page.Container>
      <Page.Heading>
        <h1>Settings</h1>
        <div className="text-[#464f60]">
          Manage your subscription and account details.
        </div>
      </Page.Heading>
      <Page.Body>
        <Tabs defaultValue="billing">
          <Flex.Col className="gap-5">
            <TabsList>
              <TabsTrigger value="billing">Billing</TabsTrigger>
              <TabsTrigger value="account">Account information</TabsTrigger>
            </TabsList>
            <TabsContent value="billing">
              <BillingPage />
            </TabsContent>
            <TabsContent value="account">
              <AccountPage />
            </TabsContent>
          </Flex.Col>
        </Tabs>
      </Page.Body>
    </Page.Container>
  );
}
